import { Text, Link } from "@chakra-ui/react";
import { THEME_COLOR_SCHEME } from "../utils/theme";
import { Link as ReactRouterLink } from "react-router-dom";
import { Note } from "common";
import { NoteBody } from "./NoteBody";
import { useNoteAccount } from "./useNoteAccount";
import { useNoteAccountName } from "./useNoteAccountName";
import { useNoteTeam } from "./useNoteTeam";
import { useNoteYouthKid } from "./useNoteYouthKid";
import { useNoteYouthKidName } from "./useNoteYouthKidName";

interface NoteUpdateYouthKidBodyProps {
  note: Note;
}

export const NoteUpdateYouthKidBody = ({
  note,
}: NoteUpdateYouthKidBodyProps) => {
  const account = useNoteAccount(note);
  const accountName = useNoteAccountName(note);
  const youthKid = useNoteYouthKid(note);
  const youthKidName = useNoteYouthKidName(note);
  const team = useNoteTeam(note);

  return (
    <NoteBody note={note}>
      <Text width={"100%"} textAlign={"center"} marginLeft={2} marginRight={2}>
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/account/${account?.id}`}
        >
          {accountName}
        </Link>
        {team ? ` added youth kid "` : ` updated youth kid "`}
        <Link
          color={THEME_COLOR_SCHEME}
          as={ReactRouterLink}
          to={`/youth-kid/${youthKid?.id}`}
        >
          {youthKidName}
        </Link>
        "{team ? ` to team ` : null}
        {team ? (
          <Link
            color={THEME_COLOR_SCHEME}
            as={ReactRouterLink}
            to={`/team/${team.id}`}
          >
            {team.name}
          </Link>
        ) : null}
      </Text>
    </NoteBody>
  );
};
